module.exports = __webpack_public_path__ + "static/9-mission1-success-25d1fd7a1e778cc4cb7337d769de7066.png";